import { NavigationContainer } from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import { SCREENS } from "navigation/consts";
import MainNavigation from "navigation/MainNavigation";
import Login from "views/Login";
import { useUserContext } from "contexts/UserContext";
import { useVenueContext } from "contexts/VenueContext";
import VenueLogin from "views/VenueLogin";
import TicketDetails from "views/TicketDetails";
import { useIntl } from "react-intl";
import EventList from "views/EventList";
import useInnerSize from "hooks/useInnerSize";

import { Wrapper } from "./styles";
import { LINKING_OPTIONS } from "./consts";
import { RootNavigationParamList } from "./types";
import { useRootNavigationTheme } from "./hooks";
import { documentTitleFormatter } from "./utils";

const { Navigator, Screen } = createStackNavigator<RootNavigationParamList>();

const RootNavigation: React.FC = () => {
  const intl = useIntl();
  const theme = useRootNavigationTheme();
  const { user } = useUserContext();
  const { venue } = useVenueContext();
  const { height: innerHeight } = useInnerSize();

  return (
    <Wrapper $height={innerHeight}>
      <NavigationContainer
        linking={LINKING_OPTIONS}
        documentTitle={{ formatter: documentTitleFormatter }}
        {...{ theme }}
      >
        <Navigator
          screenOptions={{
            headerTitleAlign: "center",
            headerShown: false,
          }}
        >
          {!user && <Screen name={SCREENS.Login} component={Login} />}
          {user && (
            <Screen
              name={SCREENS.VenueLogin}
              component={VenueLogin}
              options={{
                title: intl.formatMessage({ defaultMessage: "Select Venue" }),
              }}
            />
          )}
          {user && venue && (
            <>
              <Screen
                name={SCREENS.EventList}
                component={EventList}
                options={{
                  title: intl.formatMessage({ defaultMessage: "Events" }),
                  headerShown: true,
                }}
              />
              <Screen name={SCREENS.Main} component={MainNavigation} />
              <Screen
                name={SCREENS.TicketDetails}
                component={TicketDetails}
                options={{
                  title: intl.formatMessage({ defaultMessage: "Ticket" }),
                  presentation: "modal",
                  headerShown: true,
                }}
              />
            </>
          )}
        </Navigator>
      </NavigationContainer>
    </Wrapper>
  );
};

export default RootNavigation;
